import {createAction, props} from '@ngrx/store';

export const trackedPageView = createAction(
  '[Google Analytics] Pushed PageView Tracking Event to DataLayer',
  props<{payload: any}>()
);
